module.exports = __webpack_public_path__ + "static/media/to-do-app.48d145d1.PNG";